module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [(this.$route.query.type == 'equipment') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Equipment information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Vendor name",
      "prop": "vendorName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Vendor name"
    },
    model: {
      value: (_vm.uploadForm.vendorName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorName", $$v)
      },
      expression: "uploadForm.vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "vendorPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.vendorPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorPhone", $$v)
      },
      expression: "uploadForm.vendorPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vendor address",
      "prop": "vendorAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40
    },
    model: {
      value: (_vm.uploadForm.vendorAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorAddress", $$v)
      },
      expression: "uploadForm.vendorAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "vendorCity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30
    },
    model: {
      value: (_vm.uploadForm.vendorCity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorCity", $$v)
      },
      expression: "uploadForm.vendorCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "State",
      "prop": "vendorState"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.uploadForm.vendorState),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorState", $$v)
      },
      expression: "uploadForm.vendorState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip code",
      "prop": "vendorZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "5-digit postal code",
      "maxlength": 5
    },
    model: {
      value: (_vm.uploadForm.vendorZipCode),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorZipCode", $$v)
      },
      expression: "uploadForm.vendorZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Equipment amount",
      "prop": "equipmentAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.equipmentAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentAmount", $$v)
      },
      expression: "uploadForm.equipmentAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment status",
      "prop": "equipmentStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment status"
    },
    model: {
      value: (_vm.uploadForm.equipmentStatus),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentStatus", $$v)
      },
      expression: "uploadForm.equipmentStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Down Payment?",
      "prop": "wantDownPayment"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Do you want to pay a down payment?"
    },
    model: {
      value: (_vm.uploadForm.wantDownPayment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "wantDownPayment", $$v)
      },
      expression: "uploadForm.wantDownPayment"
    }
  }, _vm._l((_vm.downPaymentOrNot), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Reason for equipment purchase",
      "prop": "reasonForEquipment"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Reason for equipment purchase"
    },
    model: {
      value: (_vm.uploadForm.reasonForEquipment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "reasonForEquipment", $$v)
      },
      expression: "uploadForm.reasonForEquipment"
    }
  }, _vm._l((_vm.reasonsForEquipment), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment type",
      "prop": "equipmentType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "What kind of equipment are you financing?"
    },
    model: {
      value: (_vm.uploadForm.equipmentType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentType", $$v)
      },
      expression: "uploadForm.equipmentType"
    }
  }, _vm._l((_vm.equipmentTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Equipment description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.uploadForm.equipmentDesc),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentDesc", $$v)
      },
      expression: "uploadForm.equipmentDesc"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (this.$route.query.type == 'billing') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Billing information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Average monthly billing",
      "prop": "averageMonthlyBilling"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageMonthlyBilling),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageMonthlyBilling", $$v)
      },
      expression: "uploadForm.averageMonthlyBilling"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Desired factoring amount",
      "prop": "desiredFactoringAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.desiredFactoringAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "desiredFactoringAmount", $$v)
      },
      expression: "uploadForm.desiredFactoringAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Average invoice size",
      "prop": "averageInvoiceSize"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageInvoiceSize),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageInvoiceSize", $$v)
      },
      expression: "uploadForm.averageInvoiceSize"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Largest invoice",
      "prop": "largestInvoice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.largestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "largestInvoice", $$v)
      },
      expression: "uploadForm.largestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Smallest invoice",
      "prop": "smallestInvoice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.smallestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "smallestInvoice", $$v)
      },
      expression: "uploadForm.smallestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you bill in progress stages?",
      "prop": "anyBillInProgress"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyBillInProgress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyBillInProgress", $$v)
      },
      expression: "uploadForm.anyBillInProgress"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are any sales bill and hold?",
      "prop": "anySalesBillHold"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anySalesBillHold),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anySalesBillHold", $$v)
      },
      expression: "uploadForm.anySalesBillHold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer information")])]), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#1")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName1", $$v)
      },
      expression: "uploadForm.customerBusinessName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail1", $$v)
      },
      expression: "uploadForm.customerEmail1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress1", $$v)
      },
      expression: "uploadForm.customerAddress1"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone1", $$v)
      },
      expression: "uploadForm.customerPhone1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax1", $$v)
      },
      expression: "uploadForm.customerFax1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite1", $$v)
      },
      expression: "uploadForm.customerWebsite1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms1", $$v)
      },
      expression: "uploadForm.customerPaymentTerms1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance1", $$v)
      },
      expression: "uploadForm.customerCurrentBalance1"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#2")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName2", $$v)
      },
      expression: "uploadForm.customerBusinessName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail2", $$v)
      },
      expression: "uploadForm.customerEmail2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress2", $$v)
      },
      expression: "uploadForm.customerAddress2"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone2", $$v)
      },
      expression: "uploadForm.customerPhone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax2", $$v)
      },
      expression: "uploadForm.customerFax2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite2", $$v)
      },
      expression: "uploadForm.customerWebsite2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms2", $$v)
      },
      expression: "uploadForm.customerPaymentTerms2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance2", $$v)
      },
      expression: "uploadForm.customerCurrentBalance2"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#3")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName3", $$v)
      },
      expression: "uploadForm.customerBusinessName3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail3", $$v)
      },
      expression: "uploadForm.customerEmail3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress3", $$v)
      },
      expression: "uploadForm.customerAddress3"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone3", $$v)
      },
      expression: "uploadForm.customerPhone3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax3", $$v)
      },
      expression: "uploadForm.customerFax3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite3", $$v)
      },
      expression: "uploadForm.customerWebsite3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms3", $$v)
      },
      expression: "uploadForm.customerPaymentTerms3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance3", $$v)
      },
      expression: "uploadForm.customerCurrentBalance3"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#4")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName4", $$v)
      },
      expression: "uploadForm.customerBusinessName4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail4", $$v)
      },
      expression: "uploadForm.customerEmail4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress4", $$v)
      },
      expression: "uploadForm.customerAddress4"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone4", $$v)
      },
      expression: "uploadForm.customerPhone4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax4", $$v)
      },
      expression: "uploadForm.customerFax4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite4", $$v)
      },
      expression: "uploadForm.customerWebsite4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms4", $$v)
      },
      expression: "uploadForm.customerPaymentTerms4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance4", $$v)
      },
      expression: "uploadForm.customerCurrentBalance4"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#5")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName5", $$v)
      },
      expression: "uploadForm.customerBusinessName5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail5", $$v)
      },
      expression: "uploadForm.customerEmail5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress5", $$v)
      },
      expression: "uploadForm.customerAddress5"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone5", $$v)
      },
      expression: "uploadForm.customerPhone5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax5", $$v)
      },
      expression: "uploadForm.customerFax5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite5", $$v)
      },
      expression: "uploadForm.customerWebsite5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms5", $$v)
      },
      expression: "uploadForm.customerPaymentTerms5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance5", $$v)
      },
      expression: "uploadForm.customerCurrentBalance5"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any outstanding loans/advances?",
      "prop": "anyOutstandingLoans"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyOutstandingLoans),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyOutstandingLoans", $$v)
      },
      expression: "uploadForm.anyOutstandingLoans"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Is your inventory/receivables pledged as collateral?",
      "prop": "ifReceivablesAsCollateral"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifReceivablesAsCollateral),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifReceivablesAsCollateral", $$v)
      },
      expression: "uploadForm.ifReceivablesAsCollateral"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name of financial institution",
      "prop": "nameOfFinancialInstitution"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.nameOfFinancialInstitution),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "nameOfFinancialInstitution", $$v)
      },
      expression: "uploadForm.nameOfFinancialInstitution"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan amount and terms",
      "prop": "loanAmountAndTerms"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.loanAmountAndTerms),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "loanAmountAndTerms", $$v)
      },
      expression: "uploadForm.loanAmountAndTerms"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are your federal, state, & payroll taxes current?",
      "prop": "ifCurrentTaxesPaid"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifCurrentTaxesPaid),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifCurrentTaxesPaid", $$v)
      },
      expression: "uploadForm.ifCurrentTaxesPaid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If No: Federal taxes owed?",
      "prop": "federalTaxesOwed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.federalTaxesOwed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "federalTaxesOwed", $$v)
      },
      expression: "uploadForm.federalTaxesOwed"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State taxes owed?",
      "prop": "stateTaxesOwed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.stateTaxesOwed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "stateTaxesOwed", $$v)
      },
      expression: "uploadForm.stateTaxesOwed"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any liens been placed?",
      "prop": "anyLiensPlaced"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLiensPlaced),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLiensPlaced", $$v)
      },
      expression: "uploadForm.anyLiensPlaced"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are you on a payment plan?",
      "prop": "anyPaymentPlan"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyPaymentPlan),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyPaymentPlan", $$v)
      },
      expression: "uploadForm.anyPaymentPlan"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly payment",
      "prop": "monthlyPayment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.monthlyPayment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "monthlyPayment", $$v)
      },
      expression: "uploadForm.monthlyPayment"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Legal information")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is the company or any officer involved in any type of litigation or lawsuit?",
      "prop": "anyLawsuit"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLawsuit),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLawsuit", $$v)
      },
      expression: "uploadForm.anyLawsuit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company attorney",
      "prop": "companyAttorney"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.companyAttorney),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAttorney", $$v)
      },
      expression: "uploadForm.companyAttorney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attorney phone",
      "prop": "companyAttorneyPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.companyAttorneyPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAttorneyPhone", $$v)
      },
      expression: "uploadForm.companyAttorneyPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company accountant",
      "prop": "companyAccountant"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.companyAccountant),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAccountant", $$v)
      },
      expression: "uploadForm.companyAccountant"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Accountant phone",
      "prop": "companyAccountantPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.companyAccountantPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAccountantPhone", $$v)
      },
      expression: "uploadForm.companyAccountantPhone"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.$route.query.type == 'realEstate') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Property information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Street address",
      "prop": "streetAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.streetAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "streetAddress", $$v)
      },
      expression: "uploadForm.streetAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address line 2",
      "prop": "streetAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.streetAddress2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "streetAddress2", $$v)
      },
      expression: "uploadForm.streetAddress2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.city),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "city", $$v)
      },
      expression: "uploadForm.city"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.uploadForm.state),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "state", $$v)
      },
      expression: "uploadForm.state"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip code",
      "prop": "zip"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "5-digit postal code",
      "maxlength": 5
    },
    model: {
      value: (_vm.uploadForm.zip),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "zip", $$v)
      },
      expression: "uploadForm.zip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Building sq. ft",
      "prop": "buildingSqft"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.buildingSqft),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "buildingSqft", $$v)
      },
      expression: "uploadForm.buildingSqft"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Number of units",
      "prop": "numberOfUnits"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.numberOfUnits),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "numberOfUnits", $$v)
      },
      expression: "uploadForm.numberOfUnits"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Percent occupied %",
      "prop": "percentOccupied"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.percentOccupied),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "percentOccupied", $$v)
      },
      expression: "uploadForm.percentOccupied"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Does the owner occupy any portion of the building?",
      "prop": "ownerOccupied"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ownerOccupied),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ownerOccupied", $$v)
      },
      expression: "uploadForm.ownerOccupied"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, how many sq. ft.?",
      "prop": "ownerOccupiedSqft"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.ownerOccupiedSqft),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ownerOccupiedSqft", $$v)
      },
      expression: "uploadForm.ownerOccupiedSqft"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Property type",
      "prop": "propertyType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.uploadForm.propertyType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyType", $$v)
      },
      expression: "uploadForm.propertyType"
    }
  }, _vm._l((_vm.propertyTypeS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Property style",
      "prop": "propertyStyle"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.uploadForm.propertyStyle),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyStyle", $$v)
      },
      expression: "uploadForm.propertyStyle"
    }
  }, _vm._l((_vm.propertyStyleS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Select all options apply to the property",
      "prop": "propertyHave"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.uploadForm.propertyHave),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyHave", $$v)
      },
      expression: "uploadForm.propertyHave"
    }
  }, _vm._l((_vm.propertyHaveS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Loan information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan amount requested",
      "prop": "loanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.loanAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "loanAmount", $$v)
      },
      expression: "uploadForm.loanAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Desired rate %",
      "prop": "desiredRate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.desiredRate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "desiredRate", $$v)
      },
      expression: "uploadForm.desiredRate"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Amortization in months",
      "prop": "amortizationInMonths"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.amortizationInMonths),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "amortizationInMonths", $$v)
      },
      expression: "uploadForm.amortizationInMonths"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Yield spread premium (YSP) rebate %",
      "prop": "YSPRebate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.YSPRebate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "YSPRebate", $$v)
      },
      expression: "uploadForm.YSPRebate"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current estimated value",
      "prop": "currentEstimatedValue"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.currentEstimatedValue),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "currentEstimatedValue", $$v)
      },
      expression: "uploadForm.currentEstimatedValue"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly pmt",
      "prop": "monthlyPmt"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.monthlyPmt),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "monthlyPmt", $$v)
      },
      expression: "uploadForm.monthlyPmt"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Annual pmt",
      "prop": "annualPmt"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.annualPmt),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "annualPmt", $$v)
      },
      expression: "uploadForm.annualPmt"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Annual gross income",
      "prop": "annualGrossIncome"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.annualGrossIncome),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "annualGrossIncome", $$v)
      },
      expression: "uploadForm.annualGrossIncome"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Annual operating expense",
      "prop": "annualOperatingExpense"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.annualOperatingExpense),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "annualOperatingExpense", $$v)
      },
      expression: "uploadForm.annualOperatingExpense"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Net operating income",
      "prop": "netoperatingIncome"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.netoperatingIncome),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "netoperatingIncome", $$v)
      },
      expression: "uploadForm.netoperatingIncome"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan-to-value (LTV) %",
      "prop": "LTV"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.LTV),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "LTV", $$v)
      },
      expression: "uploadForm.LTV"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Debt-service coverage ratio (DSCR)",
      "prop": "DSCR"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.DSCR),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "DSCR", $$v)
      },
      expression: "uploadForm.DSCR"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cap rate %",
      "prop": "CAPRate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.CAPRate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "CAPRate", $$v)
      },
      expression: "uploadForm.CAPRate"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Choose the financing type you are applying for",
      "prop": "financeType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.financeType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "financeType", $$v)
      },
      expression: "uploadForm.financeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "PURCHASE"
    }
  }, [_vm._v("PURCHASE")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "RATE AND TERM REFINANCE"
    }
  }, [_vm._v("RATE AND TERM REFINANCE")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "CASH-OUT REFINANCE"
    }
  }, [_vm._v("CASH-OUT REFINANCE")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.uploadForm.financeType == 'PURCHASE') ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "1031 exchange?",
      "prop": "is1031"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.is1031),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "is1031", $$v)
      },
      expression: "uploadForm.is1031"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current sales price",
      "prop": "currentSalesPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.currentSalesPrice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "currentSalesPrice", $$v)
      },
      expression: "uploadForm.currentSalesPrice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Target closing date [MM/DD/YYYY]",
      "prop": "targetClosingDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.targetClosingDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "targetClosingDate", $$v)
      },
      expression: "uploadForm.targetClosingDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.uploadForm.financeType == 'RATE AND TERM REFINANCE' || _vm.uploadForm.financeType == 'CASH-OUT REFINANCE') ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current loan balance",
      "prop": "currentLoanBalance"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.currentLoanBalance),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "currentLoanBalance", $$v)
      },
      expression: "uploadForm.currentLoanBalance"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current rate %",
      "prop": "currentRate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.currentRate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "currentRate", $$v)
      },
      expression: "uploadForm.currentRate"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan maturity date [MM/DD/YYYY]",
      "prop": "loanMaturityDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.loanMaturityDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "loanMaturityDate", $$v)
      },
      expression: "uploadForm.loanMaturityDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current lender",
      "prop": "currentLender"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.currentLender),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "currentLender", $$v)
      },
      expression: "uploadForm.currentLender"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Acquisition price",
      "prop": "acquisitionPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.acquisitionPrice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "acquisitionPrice", $$v)
      },
      expression: "uploadForm.acquisitionPrice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mo/Yr acquired [MM/YYYY]",
      "prop": "MoYrAcquired"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.MoYrAcquired),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "MoYrAcquired", $$v)
      },
      expression: "uploadForm.MoYrAcquired"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Estimated cash-out available",
      "prop": "estimatedCashout"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.estimatedCashout),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "estimatedCashout", $$v)
      },
      expression: "uploadForm.estimatedCashout"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out usage 1",
      "prop": "cashoutUsage1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.cashoutUsage1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutUsage1", $$v)
      },
      expression: "uploadForm.cashoutUsage1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out amount 1",
      "prop": "cashoutAmount1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.cashoutAmount1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutAmount1", $$v)
      },
      expression: "uploadForm.cashoutAmount1"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out usage 2",
      "prop": "cashoutUsage2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.cashoutUsage2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutUsage2", $$v)
      },
      expression: "uploadForm.cashoutUsage2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out amount 2",
      "prop": "cashoutAmount2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.cashoutAmount2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutAmount2", $$v)
      },
      expression: "uploadForm.cashoutAmount2"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out usage 3",
      "prop": "cashoutUsage3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.cashoutUsage3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutUsage3", $$v)
      },
      expression: "uploadForm.cashoutUsage3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cash-out amount 3",
      "prop": "cashoutAmount3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.cashoutAmount3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "cashoutAmount3", $$v)
      },
      expression: "uploadForm.cashoutAmount3"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("List owner(s) of entity/company or property")])]), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Name #1")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Full name",
      "prop": "owner1FullName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner1FullName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1FullName", $$v)
      },
      expression: "uploadForm.owner1FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "% of ownership",
      "prop": "owner1Ownership"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner1Ownership),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1Ownership", $$v)
      },
      expression: "uploadForm.owner1Ownership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Liquidity",
      "prop": "owner1Liquidity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner1Liquidity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1Liquidity", $$v)
      },
      expression: "uploadForm.owner1Liquidity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date of birth/Founding date",
      "prop": "owner1DOBorFoundingDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner1DOBorFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1DOBorFoundingDate", $$v)
      },
      expression: "uploadForm.owner1DOBorFoundingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SSN/EIN",
      "prop": "owner1SSNorEIN"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner1SSNorEIN),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1SSNorEIN", $$v)
      },
      expression: "uploadForm.owner1SSNorEIN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full address",
      "prop": "owner1FullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner1FullAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1FullAddress", $$v)
      },
      expression: "uploadForm.owner1FullAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Owns residence?",
      "prop": "owner1OwnResidence"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.owner1OwnResidence),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1OwnResidence", $$v)
      },
      expression: "uploadForm.owner1OwnResidence"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Credit score",
      "prop": "owner1CreditScore"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner1CreditScore),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1CreditScore", $$v)
      },
      expression: "uploadForm.owner1CreditScore"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Net worth",
      "prop": "owner1NetWorth"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.owner1NetWorth),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner1NetWorth", $$v)
      },
      expression: "uploadForm.owner1NetWorth"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Name #2")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Full name",
      "prop": "owner2FullName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner2FullName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2FullName", $$v)
      },
      expression: "uploadForm.owner2FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "% of ownership",
      "prop": "owner2Ownership"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner2Ownership),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2Ownership", $$v)
      },
      expression: "uploadForm.owner2Ownership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Liquidity",
      "prop": "owner2Liquidity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner2Liquidity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2Liquidity", $$v)
      },
      expression: "uploadForm.owner2Liquidity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date of birth/Founding date",
      "prop": "owner2DOBorFoundingDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner2DOBorFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2DOBorFoundingDate", $$v)
      },
      expression: "uploadForm.owner2DOBorFoundingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SSN/EIN",
      "prop": "owner2SSNorEIN"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner2SSNorEIN),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2SSNorEIN", $$v)
      },
      expression: "uploadForm.owner2SSNorEIN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full address",
      "prop": "owner2FullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner2FullAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2FullAddress", $$v)
      },
      expression: "uploadForm.owner2FullAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Owns residence?",
      "prop": "owner2OwnResidence"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.owner2OwnResidence),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2OwnResidence", $$v)
      },
      expression: "uploadForm.owner2OwnResidence"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Credit score",
      "prop": "owner2CreditScore"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner2CreditScore),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2CreditScore", $$v)
      },
      expression: "uploadForm.owner2CreditScore"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Net worth",
      "prop": "owner2NetWorth"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.owner2NetWorth),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner2NetWorth", $$v)
      },
      expression: "uploadForm.owner2NetWorth"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Name #3")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Full name",
      "prop": "owner3FullName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner3FullName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3FullName", $$v)
      },
      expression: "uploadForm.owner3FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "% of ownership",
      "prop": "owner3Ownership"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner3Ownership),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3Ownership", $$v)
      },
      expression: "uploadForm.owner3Ownership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Liquidity",
      "prop": "owner3Liquidity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner3Liquidity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3Liquidity", $$v)
      },
      expression: "uploadForm.owner3Liquidity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date of birth/Founding date",
      "prop": "owner3DOBorFoundingDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner3DOBorFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3DOBorFoundingDate", $$v)
      },
      expression: "uploadForm.owner3DOBorFoundingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SSN/EIN",
      "prop": "owner3SSNorEIN"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner3SSNorEIN),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3SSNorEIN", $$v)
      },
      expression: "uploadForm.owner3SSNorEIN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full address",
      "prop": "owner3FullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner3FullAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3FullAddress", $$v)
      },
      expression: "uploadForm.owner3FullAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Owns residence?",
      "prop": "owner3OwnResidence"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.owner3OwnResidence),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3OwnResidence", $$v)
      },
      expression: "uploadForm.owner3OwnResidence"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Credit score",
      "prop": "owner3CreditScore"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner3CreditScore),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3CreditScore", $$v)
      },
      expression: "uploadForm.owner3CreditScore"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Net worth",
      "prop": "owner3NetWorth"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.owner3NetWorth),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner3NetWorth", $$v)
      },
      expression: "uploadForm.owner3NetWorth"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Name #4")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Full name",
      "prop": "owner4FullName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner4FullName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4FullName", $$v)
      },
      expression: "uploadForm.owner4FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "% of ownership",
      "prop": "owner4Ownership"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner4Ownership),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4Ownership", $$v)
      },
      expression: "uploadForm.owner4Ownership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Liquidity",
      "prop": "owner4Liquidity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner4Liquidity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4Liquidity", $$v)
      },
      expression: "uploadForm.owner4Liquidity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date of birth/Founding date",
      "prop": "owner4DOBorFoundingDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner4DOBorFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4DOBorFoundingDate", $$v)
      },
      expression: "uploadForm.owner4DOBorFoundingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SSN/EIN",
      "prop": "owner4SSNorEIN"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner4SSNorEIN),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4SSNorEIN", $$v)
      },
      expression: "uploadForm.owner4SSNorEIN"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Full address",
      "prop": "owner4FullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.owner4FullAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4FullAddress", $$v)
      },
      expression: "uploadForm.owner4FullAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Owns residence?",
      "prop": "owner4OwnResidence"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.owner4OwnResidence),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4OwnResidence", $$v)
      },
      expression: "uploadForm.owner4OwnResidence"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Credit score",
      "prop": "owner4CreditScore"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57"
    },
    model: {
      value: (_vm.uploadForm.owner4CreditScore),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4CreditScore", $$v)
      },
      expression: "uploadForm.owner4CreditScore"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Net worth",
      "prop": "owner4NetWorth"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.owner4NetWorth),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "owner4NetWorth", $$v)
      },
      expression: "uploadForm.owner4NetWorth"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Special situation")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Had a property foreclosed in last 3 years?",
      "prop": "anyPropertyForeclosed"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyPropertyForeclosed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyPropertyForeclosed", $$v)
      },
      expression: "uploadForm.anyPropertyForeclosed"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Filed for bankruptcy in last 5 years?",
      "prop": "anyFiledBankruptcy"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyFiledBankruptcy),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyFiledBankruptcy", $$v)
      },
      expression: "uploadForm.anyFiledBankruptcy"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Missed mortgage payments in last 12 months?",
      "prop": "anyMissedMortgage"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyMissedMortgage),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyMissedMortgage", $$v)
      },
      expression: "uploadForm.anyMissedMortgage"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Failed to file federal tax returns for last 3 years?",
      "prop": "anyFailedFederalTaxReturn"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyFailedFederalTaxReturn),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyFailedFederalTaxReturn", $$v)
      },
      expression: "uploadForm.anyFailedFederalTaxReturn"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Are an borrowers or guarantors a foreign national?",
      "prop": "anyForeignNational"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyForeignNational),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyForeignNational", $$v)
      },
      expression: "uploadForm.anyForeignNational"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Are there back real estate taxes owed on subject property?",
      "prop": "anyRealEstateTaxOwed"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.uploadForm.anyRealEstateTaxOwed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyRealEstateTaxOwed", $$v)
      },
      expression: "uploadForm.anyRealEstateTaxOwed"
    }
  }, _vm._l((_vm.yesOrNo), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Comments - other pertinent information about the deal"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.uploadForm.reComment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "reComment", $$v)
      },
      expression: "uploadForm.reComment"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("submit")])], 1), _vm._v(" "), _c('br')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd6d088a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/UpdateLoan.vue
// module id = 2017
// module chunks = 5